import { render, staticRenderFns } from "./EditSecrets.vue?vue&type=template&id=1e1a7a7a"
import script from "./EditSecrets.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditSecrets.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports